export default {
  liveManagement: {
    tab1:'授权管理',
    tab2:'当前直播房间',
    room_id:'房间id',
    user_id:'用户id',
    addAuth:'添加授权',
    country:'国家',
    room_owner:'房主id',
    live_user:'直播用户id',
    expireTime:'过期时间',
    title1:'添加授权',
    title2:'编辑授权',

    authAccount:'授权帐号',
    authPassword:'授权密码',
    live_password:'直播密码',
    authCode:'直播授权码',

    video_url:'视频流地址',

    edit_room:'编辑直播间',
    close_live:'关闭直播',

    liveStatus:'直播状态',
    validity:'有效期',

    all:'全部',
    livingStatus:'直播中',
    notLive:'未直播',

    expired:'已过期',
    valid:'有效',

    remark:'备注',
    now:'现在',

    liveTimes:'直播次数',
    totalTime:'直播时长',
    joinTime:'最后直播时间',

    operate_time:'最后编辑时间',
    operateUser:'最后编辑人',

    formText1:'是否白名单',

    batchDelete:'批量删除',

    theme:'主题',

    sureDelete:'确认删除吗?',

    publicLive:'公共',
    privateLive:'私人',
  }
}



// WEBPACK FOOTER //
// ./src/language/liveManagement.js